import React, { memo } from 'react';
import { ButtonCTA } from '../components/ButtonCTA';
import { FAQAccordion } from '../components/FAQAccordion';
import { CountdownTimer } from '../components/CountdownTimer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { CheckCircle2, Star, Clock, ShieldCheck, Sparkles, Moon, BookOpen, Heart, Activity, ArrowDown, Gift, Zap, Brain, Coffee, Leaf, Flame, Lock, Download, Award, Users, TrendingUp } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-sand-50 font-sans text-earth-900 selection:bg-terracotta-100 selection:text-terracotta-700 overflow-x-hidden" data-id="element-47">
      {/* 1. Sticky Announcement Bar with Countdown - reverted */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-terracotta-700 via-terracotta-600 to-terracotta-700 text-white py-2.5 px-4 text-center shadow-lg border-b-2 border-gold-500" data-id="element-48">
        <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap text-sm sm:text-base" data-id="element-49">
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-50" />
          <span className="font-bold tracking-wide" data-id="element-51">
            Alivio para cuello, mandíbula, cabeza y espalda · 85% OFF — Termina
            en:
          </span>
          <CountdownTimer variant="bar" data-id="element-52" />
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-53" />
        </div>
      </div>

      {/* Scarcity Bar */}
      <div className="bg-earth-900 text-sand-50 py-2 px-4 text-center text-xs sm:text-sm" data-id="element-54">
        <span className="inline-flex items-center gap-2 flex-wrap justify-center" data-id="element-55">
          <Users className="w-4 h-4 text-gold-500" data-id="element-56" />
          <span data-id="element-57">
            <span className="font-bold text-gold-500" data-id="element-58">347 personas</span> viendo
            esta página
          </span>
          <span className="hidden sm:inline text-earth-600" data-id="element-59">•</span>
          <span data-id="element-60">
            <span className="font-bold text-gold-500" data-id="element-61">73 vendidos HOY</span>
          </span>
          <span className="hidden sm:inline text-earth-600" data-id="element-62">•</span>
          <span data-id="element-63">
            <span className="font-bold text-gold-500" data-id="element-64">Solo 14 cupos</span> a
            este precio
          </span>
        </span>
      </div>

      {/* 2. Hero Section — short, captivating, single-column */}
      <section className="relative pt-10 pb-12 lg:pt-14 lg:pb-16 px-4 overflow-hidden" data-id="element-65">
        {/* Background blurs */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-66">
          <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-blush-100/70 blur-3xl" data-id="element-67"></div>
          <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-sage-100/60 blur-3xl" data-id="element-68"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-69">
          <div className="space-y-5" data-id="element-70">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-gold-500/20 via-gold-500/30 to-gold-500/20 border border-gold-500/40 text-earth-900 text-xs font-bold tracking-[0.15em] uppercase" data-id="element-71">
              <Sparkles className="w-3.5 h-3.5 text-gold-500" data-id="element-72" />
              Alivio Natural del Dolor · Argentina
              <Sparkles className="w-3.5 h-3.5 text-gold-500" data-id="element-73" />
            </div>

            {/* Italic eyebrow */}
            <p className="font-serif italic text-xl sm:text-2xl text-terracotta-700 leading-snug max-w-2xl mx-auto" data-id="element-74">
              Imaginá despertarte mañana sin ese cuello duro, sin la mandíbula
              apretada, sin esa cabeza pesada…
            </p>

            {/* Big bold H1 */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold leading-[1.05] text-earth-900 tracking-tight" data-id="element-75">
              Aprendé qué
              <span className="relative inline-block mx-2" data-id="element-76">
                <span className="relative z-10" data-id="element-77">puntos tocar</span>
                <span className="absolute bottom-1 left-0 right-0 h-3 sm:h-4 bg-gold-500/40 -z-0 rounded" data-id="element-78"></span>
              </span>
              para frenar el dolor de cuello, mandíbula, cabeza y espalda.
            </h1>

            {/* Short body */}
            <p className="text-base sm:text-lg text-earth-700 leading-relaxed max-w-xl mx-auto" data-id="element-79">
              Auriculoterapia + Reflexología en casa.{' '}
              <span className="font-semibold text-earth-900" data-id="element-80">
                Sin agujas. Sin turnos. Sin médicos.
              </span>
            </p>

            {/* CTA */}
            <div className="pt-2 flex flex-col items-center gap-4" data-id="element-81">
              <ButtonCTA text="QUIERO ALIVIAR MI DOLOR HOY" subtext="Acceso inmediato · Garantía 7 días" showGuarantee data-id="element-82" />

              {/* Trust row */}
              <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-earth-700" data-id="element-83">
                <div className="flex items-center gap-1.5" data-id="element-84">
                  <div className="flex text-gold-500" data-id="element-85">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-86" />)}
                  </div>
                  <span className="font-semibold" data-id="element-87">4.9/5</span>
                </div>
                <span className="text-earth-400" data-id="element-88">·</span>
                <div className="flex items-center gap-1.5" data-id="element-89">
                  <Users className="w-4 h-4 text-sage-600" data-id="element-90" />
                  <span data-id="element-91">
                    <strong data-id="element-92">+2.000</strong> personas ya lo usan
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Problem Section — calm version, no cost-of-inaction block */}
      <section className="py-10 bg-earth-900 text-sand-50 px-4 relative overflow-hidden" data-id="element-93">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-terracotta-900/40 via-transparent to-transparent pointer-events-none" data-id="element-94"></div>

        <div className="max-w-4xl mx-auto text-center space-y-12 relative z-10" data-id="element-95">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-terracotta-100" data-id="element-96">
            ¿Te duele el cuello, la mandíbula, la cabeza o la espalda?
          </h2>

          <div className="flex flex-wrap justify-center gap-3 sm:gap-4" data-id="element-97">
            {['Dolor de cuello', 'Mandíbula apretada', 'Dolor de cabeza', 'Dolor de espalda', 'Bruxismo', 'Migrañas', 'Contracturas'].map((symptom, i) => <span key={i} className="px-4 py-2 rounded-full bg-earth-800/50 border border-earth-700 text-sand-100 font-medium" data-id="element-98">
                {symptom}
              </span>)}
          </div>

          <div className="space-y-6 text-xl sm:text-2xl font-serif text-sand-200 leading-relaxed max-w-3xl mx-auto" data-id="element-99">
            <p data-id="element-100">El cuello duro. La mandíbula apretada. La cabeza que late.</p>
            <p data-id="element-101">La espalda tensionada que no afloja, hagas lo que hagas.</p>
            <p className="text-3xl sm:text-4xl font-bold text-white pt-4" data-id="element-102">
              ESO NO ES NORMAL.
            </p>
          </div>

          <p className="text-lg text-earth-300 max-w-2xl mx-auto" data-id="element-103">
            Cuello, mandíbula, cabeza y espalda son los 4 lugares donde el
            cuerpo acumula más tensión. Y cuanto más tiempo pasa, peor se
            siente.
          </p>
        </div>
      </section>

      {/* Stat strip — hard claims */}
      <section className="bg-gradient-to-r from-terracotta-600 via-terracotta-700 to-terracotta-600 text-white py-10 px-4 border-y-2 border-gold-500" data-id="element-104">
        <div className="max-w-5xl mx-auto grid grid-cols-3 gap-4 sm:gap-8 text-center" data-id="element-105">
          {[{
          num: '92%',
          label: 'reporta menos dolor en 7 días'
        }, {
          num: '+2.000',
          label: 'personas ya lo están usando'
        }, {
          num: '4.9/5',
          label: 'puntaje promedio de satisfacción'
        }].map((s, i) => <div key={i} className="flex flex-col items-center" data-id="element-106">
              <p className="text-3xl sm:text-5xl font-black font-serif text-gold-400 leading-none mb-2" data-id="element-107">
                {s.num}
              </p>
              <p className="text-xs sm:text-sm text-sand-100 leading-tight max-w-[160px]" data-id="element-108">
                {s.label}
              </p>
            </div>)}
        </div>
      </section>

      {/* 4 Pain-specific cards — what's happening and how the method fixes it */}
      <section className="py-10 px-4 bg-white" data-id="element-109">
        <div className="max-w-6xl mx-auto" data-id="element-110">
          <div className="text-center mb-12" data-id="element-111">
            <p className="text-terracotta-700 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-3" data-id="element-112">
              Cada dolor tiene su punto
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-4 leading-tight" data-id="element-113">
              Qué te pasa y{' '}
              <span className="italic text-terracotta-700" data-id="element-114">
                cómo lo aliviás
              </span>
            </h2>
            <p className="text-lg text-earth-700 max-w-2xl mx-auto" data-id="element-115">
              El método te da un protocolo distinto para cada zona. Esto es lo
              que vas a aprender:
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5 sm:gap-6" data-id="element-116">
            {[{
            icon: Activity,
            title: 'Dolor de cuello',
            cause: 'Postura, pantallas y estrés acumulado en la zona cervical.',
            solution: 'Puntos específicos en oído + reflejo cervical en manos y pies para liberar la tensión.'
          }, {
            icon: Heart,
            title: 'Mandíbula apretada',
            cause: 'Bruxismo, ansiedad y tensión inconsciente al dormir o trabajar.',
            solution: 'Combinación de puntos auriculares + reflejo mandibular para soltar la zona.'
          }, {
            icon: Brain,
            title: 'Dolor de cabeza',
            cause: 'Tensión muscular, estrés visual y carga emocional acumulada.',
            solution: 'Mapa de puntos para migraña, jaqueca y cefalea tensional en 5 minutos.'
          }, {
            icon: Leaf,
            title: 'Dolor de espalda',
            cause: 'Contracturas, mala postura y carga lumbar o dorsal crónica.',
            solution: 'Reflejos en pies + puntos lumbares y dorsales para descontracturar sin masaje.'
          }].map((p, i) => <div key={i} className="bg-sand-50 border border-sand-200 rounded-3xl p-6 sm:p-7 hover:shadow-lg transition-shadow" data-id="element-117">
                <div className="flex items-center gap-3 mb-4" data-id="element-118">
                  <div className="w-12 h-12 rounded-full bg-terracotta-100 flex items-center justify-center flex-shrink-0" data-id="element-119">
                    <p.icon className="w-6 h-6 text-terracotta-700" data-id="element-120" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-serif font-bold text-earth-900" data-id="element-121">
                    {p.title}
                  </h3>
                </div>
                <div className="space-y-3" data-id="element-122">
                  <div data-id="element-123">
                    <p className="text-xs font-bold uppercase tracking-wider text-earth-500 mb-1" data-id="element-124">
                      Qué pasa
                    </p>
                    <p className="text-earth-700" data-id="element-125">{p.cause}</p>
                  </div>
                  <div className="pt-3 border-t border-sand-200" data-id="element-126">
                    <p className="text-xs font-bold uppercase tracking-wider text-sage-700 mb-1" data-id="element-127">
                      Cómo lo aliviás
                    </p>
                    <p className="text-earth-900 font-medium" data-id="element-128">{p.solution}</p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 flex justify-center" data-id="element-129">
            <ButtonCTA text="QUIERO MI PROTOCOLO" subtext="Garantía 7 días · Acceso inmediato" showGuarantee data-id="element-130" />
          </div>
        </div>
      </section>

      {/* ¿Por qué esto SÍ funciona? — Comparison section (original) */}
      <section className="py-10 px-4 bg-sand-50 relative" data-id="element-131">
        <div className="max-w-5xl mx-auto" data-id="element-132">
          <div className="text-center mb-12" data-id="element-133">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-50 border border-terracotta-200 text-terracotta-700 text-xs sm:text-sm font-bold tracking-wide uppercase mb-4" data-id="element-134">
              <Sparkles className="w-3.5 h-3.5" data-id="element-135" />
              La diferencia
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-4 leading-tight" data-id="element-136">
              ¿Por qué este método{' '}
              <span className="text-terracotta-600 italic" data-id="element-137">sí funciona</span> y
              otras cosas no?
            </h2>
            <p className="text-lg text-earth-700 max-w-2xl mx-auto" data-id="element-138">
              Si ya probaste otras opciones y el dolor sigue volviendo, esto es
              lo que las diferencia:
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-sand-200 overflow-hidden" data-id="element-139">
            {/* Header row */}
            <div className="grid grid-cols-5 bg-earth-900 text-white text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-140">
              <div className="p-4 sm:p-5 col-span-2" data-id="element-141">Lo que probaste</div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-142">
                Costo
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-143">
                Resultados
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-144">
                En casa
              </div>
            </div>

            {[{
            name: 'Analgésicos',
            cost: 'Recurrente',
            result: 'Apaga el síntoma',
            home: false
          }, {
            name: 'Kinesiólogo',
            cost: '$$ por sesión',
            result: 'Mejora temporal',
            home: false
          }, {
            name: 'Videos de YouTube',
            cost: 'Gratis',
            result: 'Información dispersa',
            home: true
          }, {
            name: 'Tratamientos alternativos',
            cost: '$$',
            result: 'Variable',
            home: false
          }].map((row, i) => <div key={i} className="grid grid-cols-5 border-t border-sand-200 text-earth-800" data-id="element-145">
                <div className="p-4 sm:p-5 col-span-2 font-semibold" data-id="element-146">
                  {row.name}
                </div>
                <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200" data-id="element-147">
                  {row.cost}
                </div>
                <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200" data-id="element-148">
                  {row.result}
                </div>
                <div className="p-4 sm:p-5 text-center border-l border-sand-200" data-id="element-149">
                  {row.home ? <CheckCircle2 className="w-5 h-5 text-sage-500 mx-auto" data-id="element-150" /> : <span className="text-red-400 font-bold text-xl" data-id="element-151">✗</span>}
                </div>
              </div>)}

            {/* This product row — highlighted */}
            <div className="grid grid-cols-5 border-t-2 border-gold-500 bg-gradient-to-r from-gold-500/10 via-sand-50 to-gold-500/10 text-earth-900" data-id="element-152">
              <div className="p-4 sm:p-5 col-span-2 font-bold flex items-center gap-2" data-id="element-153">
                <Sparkles className="w-5 h-5 text-gold-500" data-id="element-154" />
                Este bundle
              </div>
              <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200 font-bold" data-id="element-155">
                $16.990 una vez
              </div>
              <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200 font-bold" data-id="element-156">
                Alivio duradero
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-sand-200" data-id="element-157">
                <CheckCircle2 className="w-6 h-6 text-sage-600 mx-auto" data-id="element-158" />
              </div>
            </div>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4" data-id="element-159">
            {[{
            label: 'Sin agujas',
            sub: 'Solo presión con tus manos'
          }, {
            label: 'Pago único',
            sub: 'Sin suscripciones ni cuotas'
          }, {
            label: 'Para siempre',
            sub: 'Lo usás cuando lo necesites'
          }].map((item, i) => <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-2xl border border-sand-200" data-id="element-160">
                <CheckCircle2 className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-161" />
                <div data-id="element-162">
                  <p className="font-bold text-earth-900" data-id="element-163">{item.label}</p>
                  <p className="text-sm text-earth-600" data-id="element-164">{item.sub}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 flex justify-center" data-id="element-165">
            <ButtonCTA text="QUIERO PROBAR EL MÉTODO" subtext="Garantía 7 días · Acceso inmediato" showGuarantee data-id="element-166" />
          </div>
        </div>
      </section>

      {/* 5. Product Breakdown — RESTORED with screenshot previews */}
      <section className="py-10 px-4 bg-sand-100 relative" data-id="element-167">
        <div className="max-w-6xl mx-auto space-y-12" data-id="element-168">
          <div className="text-center" data-id="element-169">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-170">
              Todo lo que necesitás para frenar el dolor
            </h2>
            <p className="text-lg text-earth-600" data-id="element-171">
              2 ebooks + 6 bonus pensados para atacar cuello, mandíbula, cabeza
              y espalda.
            </p>
          </div>

          {/* Ebook 1 — Reflexología */}
          <div className="space-y-8" data-id="element-172">
            <div className="grid md:grid-cols-2 gap-8 items-center bg-white p-6 sm:p-8 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-173">
              <div className="order-2 md:order-1 space-y-6" data-id="element-174">
                <div className="inline-block px-4 py-1.5 bg-sage-100 text-sage-800 rounded-full text-sm font-bold tracking-wide" data-id="element-175">
                  EBOOK 1
                </div>
                <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-176">
                  Alivio en tus Manos
                </h3>
                <p className="text-xl text-earth-600 font-serif italic" data-id="element-177">
                  Reflexología para aliviar dolor físico y recuperar el
                  equilibrio del cuerpo
                </p>
                <p className="text-earth-800" data-id="element-178">
                  Aprendé protocolos específicos para:
                </p>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-179">
                  {['Migrañas', 'Dolor cervical', 'Dolor lumbar', 'Contracturas', 'Estrés físico', 'Insomnio', 'Dolor menstrual', 'Ansiedad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-180">
                      <CheckCircle2 className="w-5 h-5 text-sage-500" data-id="element-181" /> {item}
                    </li>)}
                </ul>
              </div>
              <div className="order-1 md:order-2 flex items-center justify-center relative" data-id="element-182">
                <div className="absolute inset-0 bg-gradient-to-tr from-sage-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-183"></div>
                <img src="https://cdn.magicpatterns.com/uploads/pZnPaA6mBGpi2qvCE38CQs/ALIVIO_EN_TUS_MANOS.png" alt="Ebook Alivio en tus Manos — Reflexología" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[-3deg] hover:rotate-0 transition-transform duration-500" data-id="element-184" />
              </div>
            </div>
          </div>

          {/* Ebook 2 — Auriculoterapia */}
          <div className="space-y-8" data-id="element-185">
            <div className="grid md:grid-cols-2 gap-8 items-center bg-white p-6 sm:p-8 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-186">
              <div className="flex items-center justify-center relative" data-id="element-187">
                <div className="absolute inset-0 bg-gradient-to-tr from-terracotta-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-188"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oqinBveycV1kdDYFdFy3sd/iculoterapia.png" alt="Ebook Puntos que Sanan — Auriculoterapia" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[3deg] hover:rotate-0 transition-transform duration-500" data-id="element-189" />
              </div>
              <div className="space-y-6" data-id="element-190">
                <div className="inline-block px-4 py-1.5 bg-terracotta-100 text-terracotta-800 rounded-full text-sm font-bold tracking-wide" data-id="element-191">
                  EBOOK 2
                </div>
                <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-192">
                  Puntos que Sanan
                </h3>
                <p className="text-xl text-earth-600 font-serif italic" data-id="element-193">
                  Auriculoterapia práctica para desactivar síntomas físicos
                  naturalmente
                </p>
                <p className="text-earth-800" data-id="element-194">
                  Descubrí los puntos exactos del oído para trabajar:
                </p>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-195">
                  {['Dolor físico', 'Tensión muscular', 'Sistema nervioso', 'Estrés acumulado', 'Ansiedad física', 'Sueño y descanso', 'Inflamación'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-196">
                      <CheckCircle2 className="w-5 h-5 text-terracotta-500" data-id="element-197" />{' '}
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          {/* Combined preview — one strip for both ebooks */}
          <div className="bg-white p-6 sm:p-8 rounded-[2rem] border border-sand-200" data-id="element-198">
            <p className="text-center text-sm font-bold uppercase tracking-wider text-terracotta-700 mb-2" data-id="element-199">
              ✦ Una mirada adentro
            </p>
            <h4 className="text-center text-2xl font-serif font-bold text-earth-900 mb-6" data-id="element-200">
              Esto es lo que vas a encontrar
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4" data-id="element-201">
              {['https://cdn.magicpatterns.com/uploads/8wrEVoNdQpZNahdYmgMLzS/Captura_de_pantalla_2026-05-11_194708.png', 'https://cdn.magicpatterns.com/uploads/p9AaPtr5kbUN6fFbQkiFxr/Captura_de_pantalla_2026-05-11_194737.png', 'https://cdn.magicpatterns.com/uploads/hTeJ3cbCt4ESMj1MNUC4Yc/Captura_de_pantalla_2026-05-11_194903.png', 'https://cdn.magicpatterns.com/uploads/hKTUYJ36GWcEMD6CxjVHvA/Captura_de_pantalla_2026-05-11_194942.png'].map((src, i) => <div key={i} className="aspect-[3/4] overflow-hidden rounded-xl border border-sand-200 shadow-md hover:shadow-xl transition-shadow bg-earth-900" data-id="element-202">
                  <img src={src} alt={`Vista previa — página ${i + 1}`} className="w-full h-full object-cover object-top" data-id="element-203" />
                </div>)}
            </div>
          </div>

          <div className="flex justify-center pt-4" data-id="element-204">
            <ButtonCTA text="QUIERO ACCEDER AHORA" showGuarantee data-id="element-205" />
          </div>
        </div>
      </section>

      {/* 6. Bonus Stack — RESTORED */}
      <section className="py-10 px-4 bg-earth-900 text-sand-50 relative overflow-hidden" data-id="element-206">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-terracotta-900/30 rounded-full blur-[100px] pointer-events-none" data-id="element-207"></div>
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-208">
          <div className="text-center mb-10" data-id="element-209">
            <h2 className="text-3xl sm:text-5xl font-serif font-bold text-white mb-4" data-id="element-210">
              Además, si te sumás hoy te llevás{' '}
              <span className="text-gold-500" data-id="element-211">6 BONUS GRATIS</span>
            </h2>
            <p className="text-xl text-earth-300" data-id="element-212">
              Herramientas extra para atacar el dolor desde todos los ángulos y
              que NO vuelva.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-213">
            {[{
            num: 1,
            title: 'Ritual de Noche',
            desc: 'Rutina de 15 min para apagar la tensión antes de dormir.'
          }, {
            num: 2,
            title: '21 Días para Sanar',
            desc: 'Plan progresivo para crear el hábito y sostener el alivio.'
          }, {
            num: 3,
            title: 'Fichas de Sanación Rápida',
            desc: 'Qué punto tocar según tu dolor — para alivio inmediato.'
          }, {
            num: 4,
            title: 'Mapa Completo de Sanación',
            desc: 'Todos los puntos de oído, manos y pies en un solo PDF.'
          }, {
            num: 5,
            title: 'El Poder del Aroma',
            desc: 'Aceites esenciales que potencian el alivio del dolor.'
          }, {
            num: 6,
            title: 'Mi Diario de Sanación',
            desc: 'Tracker para registrar tu progreso y ver el dolor bajar.'
          }].map((bonus, i) => <div key={i} className="bg-earth-800/50 border border-earth-700 p-5 rounded-2xl hover:bg-earth-800 transition-colors flex flex-col" data-id="element-214">
                <div className="flex items-center gap-3 mb-3" data-id="element-215">
                  <div className="w-9 h-9 rounded-full bg-gold-500/20 text-gold-500 flex items-center justify-center flex-shrink-0" data-id="element-216">
                    <Gift className="w-4 h-4" data-id="element-217" />
                  </div>
                  <h4 className="text-base font-serif font-bold text-white" data-id="element-218">
                    Bonus {bonus.num}
                  </h4>
                </div>
                <h5 className="text-lg font-bold text-sand-100 mb-1" data-id="element-219">
                  {bonus.title}
                </h5>
                <p className="text-earth-300 text-sm mb-4 flex-1" data-id="element-220">
                  {bonus.desc}
                </p>
                <div className="pt-3 border-t border-earth-700 flex justify-between items-center" data-id="element-221">
                  <span className="text-earth-400 text-xs line-through" data-id="element-222">
                    $11.990
                  </span>
                  <span className="text-gold-500 font-bold text-xs bg-gold-500/10 px-2.5 py-1 rounded-full" data-id="element-223">
                    HOY GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* WhatsApp-style social proof wall */}
      <section className="py-10 px-4 bg-sand-100" data-id="element-224">
        <div className="max-w-5xl mx-auto" data-id="element-225">
          <div className="text-center mb-12" data-id="element-226">
            <p className="text-terracotta-700 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-3" data-id="element-227">
              Mensajes reales que recibimos
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-3 leading-tight" data-id="element-228">
              Esto es lo que nos escriben{' '}
              <span className="italic text-terracotta-700" data-id="element-229">cada día</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-230">
            {[{
            name: 'Mariana',
            time: '14:32',
            text: 'Cheee no lo puedo creer 🥹 me hice los puntos del oído antes de dormir y por primera vez en MESES no me levanté con la mandíbula apretada'
          }, {
            name: 'Pablo',
            time: '09:18',
            text: 'Mil gracias!!! Llevaba 3 semanas con el cuello durísimo. En 2 sesiones sentí la diferencia. Lo recomiendo a todos los del laburo'
          }, {
            name: 'Sole',
            time: '21:47',
            text: 'Tenía migraña desde el mediodía, abrí la ficha rápida y en 7 minutos me bajó. Sin pastillas. Estoy IMPACTADA 🙌'
          }, {
            name: 'Federico',
            time: '08:05',
            text: 'Me levanté HOY sin dolor de espalda después de meses. No sabés lo que es esto para mí, gracias en serio 🙏'
          }, {
            name: 'Valentina',
            time: '19:23',
            text: 'Lo más fácil que probé en mi vida. Tenés el mapa, tocás el punto, listo. Para alguien con dolor crónico es ORO'
          }, {
            name: 'Tomás',
            time: '13:51',
            text: 'Pensé que iba a ser otra de esas cosas que no funcionan. Llevo 10 días y mis dolores de cabeza bajaron muchísimo. Increíble'
          }].map((m, i) => <div key={i} className="bg-white rounded-2xl shadow-sm border border-sand-200 overflow-hidden flex flex-col" data-id="element-231">
                <div className="bg-sage-50 border-b border-sand-200 px-4 py-2.5 flex items-center gap-2" data-id="element-232">
                  <div className="w-2 h-2 rounded-full bg-sage-500" data-id="element-233"></div>
                  <p className="text-xs font-semibold text-earth-700" data-id="element-234">
                    {m.name}
                  </p>
                  <span className="text-xs text-earth-400 ml-auto" data-id="element-235">
                    {m.time}
                  </span>
                </div>
                <div className="p-4 flex-1" data-id="element-236">
                  <p className="text-sm text-earth-800 leading-relaxed" data-id="element-237">
                    {m.text}
                  </p>
                  <p className="text-[10px] text-sage-600 text-right mt-2 font-semibold" data-id="element-238">
                    ✓✓ Leído
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-xs text-earth-500 mt-6 italic" data-id="element-239">
            Mensajes recibidos por nuestras redes y mail · Identidades
            modificadas por privacidad
          </p>
        </div>
      </section>

      {/* Merged: Cómo funciona + Qué vas a sentir */}
      <section className="py-10 px-4 bg-gradient-to-b from-white to-sand-50" data-id="element-240">
        <div className="max-w-5xl mx-auto" data-id="element-241">
          <div className="text-center mb-12" data-id="element-242">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-100 text-sage-900 text-xs sm:text-sm font-bold tracking-wide uppercase mb-4" data-id="element-243">
              <Leaf className="w-3.5 h-3.5" data-id="element-244" />
              Cómo funciona
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-4 leading-tight" data-id="element-245">
              3 pasos.{' '}
              <span className="text-terracotta-600 italic" data-id="element-246">
                Alivio desde el primer día.
              </span>
            </h2>
          </div>

          {/* 3 steps */}
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8 relative mb-10" data-id="element-247">
            <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-gradient-to-r from-terracotta-200 via-gold-500 to-terracotta-200 -z-0" data-id="element-248"></div>

            {[{
            step: '1',
            title: 'Abrí el PDF',
            desc: 'Acceso inmediato en tu mail. Lo abrís donde quieras.',
            icon: BookOpen
          }, {
            step: '2',
            title: 'Buscá tu dolor',
            desc: 'El mapa te muestra exactamente qué punto tocar.',
            icon: Activity
          }, {
            step: '3',
            title: 'Presioná 2-5 min',
            desc: 'Sentís el alivio empezar en la primera sesión.',
            icon: Heart
          }].map((s, i) => <div key={i} className="bg-white p-6 rounded-3xl border border-sand-200 shadow-sm relative z-10" data-id="element-249">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-terracotta-500 to-terracotta-700 flex items-center justify-center text-white shadow-xl border-4 border-white" data-id="element-250">
                  <span className="text-3xl font-black font-serif" data-id="element-251">
                    {s.step}
                  </span>
                </div>
                <div className="flex items-center justify-center mb-2" data-id="element-252">
                  <s.icon className="w-5 h-5 text-terracotta-600" data-id="element-253" />
                </div>
                <h3 className="text-xl font-serif font-bold text-earth-900 text-center mb-2" data-id="element-254">
                  {s.title}
                </h3>
                <p className="text-earth-700 text-center text-sm leading-relaxed" data-id="element-255">
                  {s.desc}
                </p>
              </div>)}
          </div>

          {/* Timeline of what you'll feel */}
          <div className="bg-earth-900 text-sand-50 rounded-3xl p-6 sm:p-10 border border-earth-700" data-id="element-256">
            <p className="text-gold-500 text-xs font-bold uppercase tracking-[0.15em] mb-2 text-center" data-id="element-257">
              ⏱ Qué vas a sentir
            </p>
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-white text-center mb-8" data-id="element-258">
              Tu cuerpo responde así:
            </h3>
            <div className="grid sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-259">
              {[{
              time: '5 min',
              title: '1ª sesión',
              text: 'Cuello y mandíbula se aflojan. Cabeza más liviana.'
            }, {
              time: '7 días',
              title: 'Una semana',
              text: 'Menos dolores de cabeza. Espalda con menos tensión.',
              featured: true
            }, {
              time: '21 días',
              title: '3 semanas',
              text: 'Hábito instalado. Episodios de dolor mucho menos frecuentes.'
            }].map((r, i) => <div key={i} className={`p-5 rounded-2xl border ${r.featured ? 'bg-gradient-to-br from-terracotta-600/30 to-earth-800 border-gold-500' : 'bg-earth-800/60 border-earth-700'}`} data-id="element-260">
                  <div className="text-gold-500 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-261">
                    {r.time}
                  </div>
                  <h4 className="text-lg font-serif font-bold text-white mb-2" data-id="element-262">
                    {r.title}
                  </h4>
                  <p className="text-sand-200 text-sm leading-relaxed" data-id="element-263">
                    {r.text}
                  </p>
                </div>)}
            </div>
            <p className="text-earth-400 italic text-xs text-center mt-6 max-w-xl mx-auto" data-id="element-264">
              * Los resultados varían según cada persona.
            </p>
          </div>

          <div className="mt-10 flex justify-center" data-id="element-265">
            <ButtonCTA text="QUIERO EMPEZAR HOY" showGuarantee data-id="element-266" />
          </div>
        </div>
      </section>

      {/* 9. FAQ Section */}
      <section className="py-10 px-4 bg-sand-50" data-id="element-267">
        <div className="max-w-4xl mx-auto" data-id="element-268">
          <div className="text-center mb-12" data-id="element-269">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-270">
              Preguntas Frecuentes
            </h2>
          </div>

          <FAQAccordion items={[{
          question: '¿Y si no me funciona a mí?',
          answer: 'Tenés 7 días de garantía total. Si después de probar el método sentís que no es para vos, te devolvemos el 100% de tu dinero. Sin preguntas. Sin trabas.'
        }, {
          question: '¿Es complicado de usar?',
          answer: 'No. Cada práctica dura entre 5 y 15 minutos. Abrís el PDF, mirás la ficha de tu dolor, presionás el punto indicado. Así de simple.'
        }, {
          question: '¿Por qué tan barato si vale $111.920?',
          answer: 'Es precio de lanzamiento. Queremos que llegue a la mayor cantidad de personas posible. Cuando termine la promo, vuelve al valor real.'
        }, {
          question: '¿Cuándo recibo el producto?',
          answer: 'Inmediatamente después de la compra, en tu correo electrónico. Lo tenés para siempre.'
        }, {
          question: '¿Necesito agujas o materiales?',
          answer: 'No. La auriculoterapia se trabaja con presión manual. Los aceites y semillas son opcionales — podés empezar solo con tus manos.'
        }, {
          question: '¿Sirve para mi tipo de dolor?',
          answer: 'Está específicamente diseñado para dolor de cuello, mandíbula, cabeza y espalda — los 4 puntos donde más se acumula la tensión. También sirve para contracturas, migrañas e insomnio.'
        }, {
          question: '¿Lo puedo usar desde el celular?',
          answer: 'Sí. Son PDFs digitales: los abrís desde celular, compu o tablet. Y también podés imprimir los mapas y fichas rápidas si querés.'
        }, {
          question: '¿Esto reemplaza un médico?',
          answer: 'No. Es una herramienta complementaria de bienestar natural. Si tenés dolor intenso o persistente, consultá con un profesional.'
        }]} data-id="element-271" />
        </div>
      </section>

      {/* Founder / credibility — "Por qué creamos este método" */}
      <section className="py-10 px-4 bg-sand-50" data-id="element-272">
        <div className="max-w-3xl mx-auto text-center" data-id="element-273">
          <div className="text-terracotta-400 text-6xl font-serif leading-none mb-4 select-none" data-id="element-274">
            ❝
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-6 leading-tight" data-id="element-275">
            Por qué creamos{' '}
            <span className="italic text-terracotta-700" data-id="element-276">este método.</span>
          </h2>

          <div className="space-y-4 text-base sm:text-lg text-earth-700 leading-relaxed" data-id="element-277">
            <p data-id="element-278">
              Después de años trabajando con personas que tenían dolor de
              cuello, espalda, cabeza y mandíbula, vimos un patrón claro:{' '}
              <strong className="text-earth-900" data-id="element-279">
                la mayoría ya había probado de todo
              </strong>{' '}
              — kinesiología, analgésicos, masajes, fisioterapia. Y todo
              ayudaba, pero el dolor siempre volvía.
            </p>
            <p data-id="element-280">
              Lo que faltaba era una herramienta{' '}
              <em className="text-terracotta-700" data-id="element-281">simple, corporal</em> y{' '}
              <em className="text-terracotta-700" data-id="element-282">
                aplicable en cualquier momento
              </em>{' '}
              — incluso en plena crisis de dolor, sin depender de turnos ni
              profesionales.
            </p>
            <p data-id="element-283">
              Así nació este bundle: la fusión de{' '}
              <strong className="text-earth-900" data-id="element-284">
                auriculoterapia china y reflexología
              </strong>
              , traducida en dos guías que cualquier persona puede aplicar desde
              su casa, sin agujas, sin riesgo y sin complicaciones.
            </p>
          </div>

          <p className="mt-10 font-serif italic text-lg text-terracotta-700" data-id="element-285">
            — Equipo Bienestar Digital
          </p>
        </div>
      </section>

      {/* NEW: Value Stack — explicit price breakdown */}
      <section className="py-10 px-4 bg-gradient-to-b from-sand-50 to-sand-100" data-id="element-286">
        <div className="max-w-4xl mx-auto" data-id="element-287">
          <div className="text-center mb-10" data-id="element-288">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/20 border border-gold-500/40 text-earth-900 text-xs sm:text-sm font-bold tracking-wide uppercase mb-4" data-id="element-289">
              <Gift className="w-3.5 h-3.5 text-gold-600" data-id="element-290" />
              Todo lo que te llevás hoy
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-4 leading-tight" data-id="element-291">
              Mirá <span className="text-terracotta-600 italic" data-id="element-292">todo</span> lo
              que te llevás para frenar el dolor
            </h2>
            <p className="text-lg text-earth-700 max-w-2xl mx-auto" data-id="element-293">
              Cada herramienta diseñada para atacar el dolor de cuello,
              mandíbula, cabeza y espalda. Valor real:{' '}
              <strong className="text-terracotta-700" data-id="element-294">$111.920</strong>.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl border border-sand-200 overflow-hidden" data-id="element-295">
            {[{
            name: 'Ebook 1: Alivio en tus Manos (Reflexología)',
            desc: 'Protocolos paso a paso para dolor de cuello, espalda, cabeza y mandíbula',
            value: '$19.990'
          }, {
            name: 'Ebook 2: Puntos que Sanan (Auriculoterapia)',
            desc: 'Mapa exacto del oído para desactivar dolor y tensión',
            value: '$19.990'
          }, {
            name: 'Bonus 1: Ritual de Noche',
            desc: 'Rutina de 15 min para soltar cuello y mandíbula antes de dormir',
            value: '$11.990'
          }, {
            name: 'Bonus 2: 21 Días para Sanar',
            desc: 'Plan progresivo para eliminar el dolor crónico paso a paso',
            value: '$11.990'
          }, {
            name: 'Bonus 3: Fichas de Sanación Rápida',
            desc: 'Qué punto tocar según tu dolor — para alivio YA',
            value: '$11.990'
          }, {
            name: 'Bonus 4: Mapa Completo de Sanación',
            desc: 'Todos los puntos para dolor de cuello, mandíbula, cabeza y espalda',
            value: '$11.990'
          }, {
            name: 'Bonus 5: El Poder del Aroma',
            desc: 'Aceites esenciales que potencian el alivio del dolor',
            value: '$11.990'
          }, {
            name: 'Bonus 6: Mi Diario de Sanación',
            desc: 'Tracker para registrar tu progreso y ver cómo baja el dolor',
            value: '$11.990'
          }].map((item, i) => <div key={i} className="grid grid-cols-12 gap-3 sm:gap-4 items-center p-4 sm:p-5 border-b border-sand-200 last:border-b-0" data-id="element-296">
                <div className="col-span-1" data-id="element-297">
                  <CheckCircle2 className="w-5 h-5 text-sage-600" data-id="element-298" />
                </div>
                <div className="col-span-8 sm:col-span-9" data-id="element-299">
                  <p className="font-bold text-earth-900 text-sm sm:text-base" data-id="element-300">
                    {item.name}
                  </p>
                  <p className="text-xs sm:text-sm text-earth-600" data-id="element-301">
                    {item.desc}
                  </p>
                </div>
                <div className="col-span-3 sm:col-span-2 text-right" data-id="element-302">
                  <span className="font-bold text-terracotta-700 text-sm sm:text-base" data-id="element-303">
                    {item.value}
                  </span>
                </div>
              </div>)}

            {/* Total row */}
            <div className="bg-earth-900 text-white p-5 sm:p-6" data-id="element-304">
              <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-305">
                <span className="text-lg sm:text-xl font-bold" data-id="element-306">
                  Valor total real:
                </span>
                <span className="text-2xl sm:text-3xl font-black text-sand-300 line-through" data-id="element-307">
                  $111.920
                </span>
              </div>
            </div>

            {/* Price row */}
            <div className="bg-gradient-to-r from-gold-500/20 via-gold-500/30 to-gold-500/20 p-6 sm:p-8 text-center border-t-2 border-gold-500" data-id="element-308">
              <p className="text-sm font-bold uppercase tracking-[0.15em] text-earth-700 mb-2 flex items-center justify-center gap-2" data-id="element-309">
                <Flame className="w-4 h-4 text-terracotta-600" data-id="element-310" />
                Hoy lo llevás por
                <Flame className="w-4 h-4 text-terracotta-600" data-id="element-311" />
              </p>
              <div className="flex items-baseline justify-center gap-3" data-id="element-312">
                <span className="text-5xl sm:text-7xl font-black text-terracotta-700 leading-none" data-id="element-313">
                  $16.990
                </span>
                <span className="text-lg text-earth-700 font-bold" data-id="element-314">ARS</span>
              </div>
              <p className="text-earth-700 mt-3 font-semibold" data-id="element-315">
                Ahorrás <span className="text-terracotta-700" data-id="element-316">$94.930</span>{' '}
                <span className="text-earth-600" data-id="element-317">(85% OFF)</span> · Pago único ·
                Acceso inmediato
              </p>
            </div>
          </div>

          {/* Guarantee block */}
          <div className="mt-8 bg-white border-2 border-sage-300 rounded-3xl p-6 sm:p-8 flex items-center gap-5 sm:gap-6 max-w-3xl mx-auto" data-id="element-318">
            <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-sage-100 border-4 border-sage-300 flex flex-col items-center justify-center flex-shrink-0" data-id="element-319">
              <Award className="w-7 h-7 sm:w-8 sm:h-8 text-sage-700" data-id="element-320" />
              <span className="text-[10px] sm:text-xs font-black text-sage-800 mt-0.5" data-id="element-321">
                7 DÍAS
              </span>
            </div>
            <div data-id="element-322">
              <p className="font-serif text-lg sm:text-2xl font-bold text-earth-900 mb-1" data-id="element-323">
                Garantía total de 7 días
              </p>
              <p className="text-earth-700 text-sm sm:text-base" data-id="element-324">
                Probalo. Si en 7 días no sentís alivio, te devolvemos el{' '}
                <strong data-id="element-325">100% de tu dinero</strong>. Sin preguntas. Sin trabas.
                El riesgo lo asumimos nosotros.
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center gap-3" data-id="element-326">
            <ButtonCTA text="SÍ, QUIERO TODO ESTO AHORA" subtext="Garantía 7 días · Acceso inmediato · Pago único" showGuarantee data-id="element-327" />
            <p className="text-sm text-earth-600 flex items-center gap-2" data-id="element-328">
              <Lock className="w-4 h-4 text-sage-600" data-id="element-329" />
              Pago 100% seguro · Tarjeta, débito o efectivo
            </p>
          </div>
        </div>
      </section>

      {/* 10. Final CTA Section */}
      <section className="py-16 px-4 bg-earth-900 text-center relative overflow-hidden" data-id="element-330">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-331"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-earth-900 via-earth-900/80 to-transparent" data-id="element-332"></div>

        <div className="max-w-3xl mx-auto relative z-10 space-y-6" data-id="element-333">
          {/* Urgency banner */}
          <div className="inline-flex items-center gap-2 bg-terracotta-600/30 border border-terracotta-500 text-terracotta-100 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-334">
            <Flame className="w-4 h-4 text-gold-500 animate-pulse" data-id="element-335" />
            Última oportunidad a este precio
            <Flame className="w-4 h-4 text-gold-500 animate-pulse" data-id="element-336" />
          </div>

          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-sand-50" data-id="element-337">
            Tu cuello, tu mandíbula, tu cabeza y tu espalda te vienen avisando.
          </h2>

          <p className="text-xl text-earth-300" data-id="element-338">
            Cada día que pasa sin hacer nada, esos 4 dolores se hacen más
            crónicos.
          </p>

          <p className="text-2xl font-serif text-sand-100 pb-2" data-id="element-339">
            Hoy podés seguir ignorándolos… o podés empezar a darle a tu cuerpo
            herramientas reales para aliviar, soltar y recuperarse.
          </p>

          {/* Hero countdown */}
          <div className="bg-earth-800/60 border border-gold-500/30 rounded-2xl p-4 max-w-md mx-auto" data-id="element-340">
            <p className="text-gold-500 text-xs font-bold uppercase tracking-[0.15em] mb-2 flex items-center justify-center gap-2" data-id="element-341">
              <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-342" /> La oferta termina
              en
            </p>
            <CountdownTimer data-id="element-343" />
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 max-w-xl mx-auto" data-id="element-344">
            <p className="inline-flex items-center gap-2 bg-gold-500 text-earth-900 px-4 py-1.5 rounded-full font-bold mb-4 text-sm uppercase tracking-wider" data-id="element-345">
              <Flame className="w-4 h-4" data-id="element-346" />
              85% OFF · Solo 14 cupos
            </p>
            <p className="text-lg text-sand-200 mb-2" data-id="element-347">
              Bundle completo + 6 bonus por:
            </p>
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-348">
              <span className="text-xl text-sand-300/70 line-through" data-id="element-349">
                $111.920
              </span>
              <span className="text-6xl sm:text-7xl font-black text-gold-500 leading-none" data-id="element-350">
                $16.990
              </span>
              <span className="text-lg text-sand-300" data-id="element-351">ARS</span>
            </div>
            <p className="text-sand-300 mb-6 text-sm" data-id="element-352">
              Pago único · Acceso inmediato · Garantía 7 días
            </p>
            <ButtonCTA text="SÍ, QUIERO EL BUNDLE AHORA" className="!w-full" data-id="element-353" />

            {/* Trust row */}
            <div className="mt-5 flex items-center justify-center gap-4 text-xs text-sand-300 flex-wrap" data-id="element-354">
              <span className="flex items-center gap-1.5" data-id="element-355">
                <Lock className="w-3.5 h-3.5 text-sage-400" data-id="element-356" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-357">
                <Download className="w-3.5 h-3.5 text-sage-400" data-id="element-358" /> Acceso
                inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-359">
                <ShieldCheck className="w-3.5 h-3.5 text-sage-400" data-id="element-360" /> Garantía 7
                días
              </span>
            </div>
          </div>

          {/* Final risk reversal */}
          <p className="text-sm text-earth-400 max-w-md mx-auto pt-2" data-id="element-361">
            Si en 7 días no sentís diferencia, te devolvemos el 100%. Literal:
            no podés perder.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-earth-950 text-earth-500 py-8 text-center text-sm" data-id="element-362">
        <p data-id="element-363">
          © {new Date().getFullYear()} Bienestar Digital. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-364">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier programa de bienestar.
        </p>
      </footer>

      {/* Floating urgency components */}
      <RecentPurchaseToast data-id="element-365" />
      <StickyMobileCTA data-id="element-366" />
    </div>;
}